var map = {
	"./bar.json": [
		8649,
		649
	],
	"./bar2.json": [
		3217,
		217
	],
	"./box1.json": [
		1376,
		376
	],
	"./dot.json": [
		9311,
		311
	],
	"./line2.json": [
		24,
		24
	],
	"./multi2.json": [
		8689,
		689
	],
	"./pie2.json": [
		3152,
		152
	],
	"./tree2.json": [
		10,
		10
	],
	"./violin1.json": [
		9732,
		732
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8701;
module.exports = webpackAsyncContext;